import { render } from "./GridDisplay.vue?vue&type=template&id=2fa4412e&scoped=true"
import script from "./GridDisplay.vue?vue&type=script&lang=js"
export * from "./GridDisplay.vue?vue&type=script&lang=js"

import "./GridDisplay.vue?vue&type=style&index=0&id=2fa4412e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa4412e"]])

export default __exports__